module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }), _c('a', {
    attrs: {
      "id": "page09"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }), _c('h2', {
    staticClass: "chapterTitle"
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/plainclothesnaked_con#fm_01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PROLOGUE")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_vm._v("Spongy buttocks exposed and wobbling, Tony Zank’s mother piled down the rest home corridor, screaming “Help me!” and “Stop the monster!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Her walker clattered off the floor and her Seventh Heaven gown clung half-on, half-off, as though she’d run through a backyard clothesline and the paper-thin garment had caught an arm.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Pretty good pipes for an oldster,” said McCardle, Zank’s sullen partner, a Dean Martin look-alike, if Dean Martin had been African-American. He added, when Zank gave him a stare, “I mean, she seems pretty upset.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Zank burped beef jerky fumes into his fist and shrugged. “She’s always upset. That’s her job. She’s been upset for fifty years.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Zank realized, with a sinking twinge, that hiding the key to his happy tomorrow in his mother’s bed, wedged between the plastic protecto-pad and the mattress beneath, had not been the brightest idea he’d ever had. But this was no time for regrets. He had to get in there and slip the envelope out before the authorities—some breed of rest home police, if there was such a thing—showed up and asked what all the shrieks were about. Asked him why, if the morning went really south, he had decided to visit his mom with a two-time loser who’d showed up on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("America’s Most Wanted")]), _vm._v(" the week before, wanted for a gay shovel murder.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Mac, reach in and grab the thing,” Zank snapped. “I’ll cover the door.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In passive-aggressive splendor, McCardle made drama of clamping his jaw and squinting as though into a strong gale.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What?” Zank hissed at him from the doorway.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m not gonna go in there and touch bedding, Tony. You can catch all kinds of stuff, reaching in old people’s beds.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Zank threw the punch before he knew he was going to, then pushed past his partner and began to tackle the mattress himself. His mother’s screams had faded, but some kind of other business was going on down the hall.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That wasn’t necessary,” McCardle mumbled. He tugged his soul patch and worked his lower lip indignantly. “I wasn’t dissing your moms. It’s just, I got a phobia, on account of after her stroke my Auntie Big’n went incontinental. I used to have to tidy up and it gave me a condition. My hands swelled up like catcher’s mitts. It was like havin’ paws, and all the kids used to make fun. I loved my auntie, even though she beat me with rolled-up magazines, but her bed gave me some kind of mitt disease.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Zank pounded the nearest wall with his fist. “Jesus Christ, enough! That’s not something I need to hear about right now, okay? That’s not something I ever need to hear about!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Okay! Down Simba…. Maybe you should lighten up on the rock, Cuz. You’re getting cranky.”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("McCardle shook his head and pinched the tiny bulb of his button nose, which looked like it had been ordered from a Make-Me-White catalogue, though he swore his entire family had been born with them. ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("That tiny nose, and his cocoa hue, were the only things that kept Mac’s Martin resemblance from being freakish. This added to Tony’s suspicion that his partner in crime had had some nasal work to keep from being stopped on the street and forced to sing “That’s Amore.”")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m only trying to tell you,” McCardle persisted, “bed stuff gets me tweaked, on account of my childhood abuse. It upsets my little McCardle. I figured it out in therapy, when I was inside.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("By now, however, Zank had stopped listening. He’d stopped hearing altogether, busy as he was peeling off Mom’s Seventh Heaven bedspread, followed by her blankets, her sheets, and her plastic pad in a frantic effort to retrieve the envelope he’d stashed. The envelope that was going to change everything.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The envelope, he realized as the sound of clicking heels and agitated female voices drew nearer, that wasn’t there anymore.")])])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page11"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-debe3d58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/plainclothesnaked_fm01.vue
// module id = 72
// module chunks = 0